import tableVodOutputs from './tableRelatedVodOutputs';

export default {
  title: 'Vod Outputs',
  attributeName: 'vodOutputs',
  getURL: 'vodOutputs',
  createURL: '',
  updateURL: '',
  removeURL: '',
  itemName: 'name',
  itemId: 'id',
  sessionParams: [],
  tableConfig: tableVodOutputs,
};
